import React, { useEffect, useState } from 'react';
import { apiRequest } from "../services/api";
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const cruiseLines = [
    {
        id: 1,
        name: 'Royal Caribbean',
        slug: 'royal-caribbean',
        logo: '/img/cruises/royal-caribbean.png',
        ships: ['Symphony of the Seas', 'Harmony of the Seas'],
    },
    {
        id: 2,
        name: 'Carnival Cruise',
        slug: 'carnival-cruise',
        logo: '/img/cruises/carnival.png',
        ships: ['Carnival Vista', 'Carnival Horizon'],
    },
    {
        id: 3,
        name: 'Norwegian Cruise',
        slug: 'norwegian-cruise',
        logo: '/img/cruises/norwegian.png',
        ships: ['Norwegian Bliss', 'Norwegian Encore', 'Norwegian Bliss', 'Norwegian Encore', 'Norwegian Bliss', 'Norwegian Encore', 'Norwegian Bliss', 'Norwegian Encore', 'Norwegian Bliss', 'Norwegian Encore'],
    },
    {
        id: 4,
        name: 'MSC Cruises',
        slug: 'msc-cruises',
        logo: '/img/cruises/msc.png',
        ships: ['MSC Seaview', 'MSC Meraviglia'],
    },
    {
        id: 5,
        name: 'Princess Cruises',
        slug: 'princess-cruises',
        logo: '/img/cruises/princess.png',
        ships: ['Majestic Princess', 'Sky Princess'],
    },
    {
        id: 6,
        name: 'Royal Caribbean',
        slug: 'royal-caribbean-2',
        logo: '/img/cruises/royal-caribbean.png',
        ships: ['Odyssey of the Seas', 'Wonder of the Seas'],
    },
    {
        id: 7,
        name: 'Carnival Cruise',
        slug: 'carnival-cruise-2',
        logo: '/img/cruises/carnival.png',
        ships: ['Carnival Celebration', 'Carnival Panorama'],
    },
    {
        id: 8,
        name: 'Norwegian Cruise Norwegian Cruise',
        slug: 'norwegian-cruise-norwegian-cruise',
        logo: '/img/cruises/norwegian.png',
        ships: ['Norwegian Joy', 'Norwegian Sun'],
    },
    {
        id: 9,
        name: 'MSC Cruises',
        slug: 'msc-cruises-2',
        logo: '/img/cruises/msc.png',
        ships: ['MSC Virtuosa', 'MSC Bellissima'],
    },
];


export default function CruiseShips() {
    const { lineSlug } = useParams();
    const { state: id } = useLocation();
    console.log('11',id);

    const [data, setData] = useState([]);
    const [cruise, setCruise] = useState('');


    useEffect(() => {
        if (id) {
            apiRequest({ url: `/cruise-line/${id}` })
                .then((res) => {
                    if (res.success) {
                        setData(res.data);
                        setCruise(res.cruise_line_name);
                    } else {
                        console.warn("Unexpected response format:", res);
                    }
                })
                .catch((err) => {
                    console.error("Error loading hero slides:", err.message);
                });
        }
    }, [id]);
    
    const cruiseLine = cruiseLines.find(line => line.slug === lineSlug);
    const navigate = useNavigate();
    
    return (
        <>
            <PageHeader
                title="Cruise Lines "
                image="../img/cruise.jpg"
                breadcrumbs={[
                    { label: "Cruise Lines", active: true },
                    { label: cruise, active: true },
                ]}
            />

            <div className='container-fluid pt-5'>
                <div className="container py-5 text-center">
                    <div className="mx-auto text-center mb-5" >
                        <h5 className="section-title px-3">{cruise}</h5>
                    </div>
                    <div className="d-flex flex-wrap justify-content-center gap-4">
                        {data.map((ship, index) => (
                            <div key={index} className="ship-card" 
                                onClick={() => navigate(`/cruise-line/${ship.slug}`, { state: ship.id })}
                            >
                                <div className="card h-100 ship-names d-flex align-items-center justify-content-center p-4 rounded shadow">
                                    <h6 className="mb-0">{ship.ship_name}</h6>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}
